import React, { FC, Fragment } from 'react';
import Loadable from 'react-loadable';
import { isUndefined } from '../../../predicates/type';
import { CustomPageWidgetComponents, CustomPageWidgets as CustomPageWidgetsType } from '../types';

const LoadableHomePageImage = Loadable({
	loader: () => import('./HomePageImage').then((m) => m.HomePageImage),
});
export const LoadableHomeJobCategory = Loadable({
	loader: () => import('./JobCategory').then((m) => m.JobCategory),
});
export const LoadableHomeLatestPublicNews = Loadable({
	loader: () => import('./LatestPublicNews').then((m) => m.LatestPublicNews),
});
export const LoadableCustomHtml = Loadable({
	loader: () => import('./CustomHtml').then((m) => m.CustomHtml),
});
export const LoadableHomeFindJobs = Loadable({
	loader: () => import('./FindJobs').then((m) => m.FindJobs),
});
export const LoadablePublicRegistrationForm = Loadable({
	loader: () => import('./PublicRegistrationForm').then((m) => m.PublicRegistrationForm),
});
export const LoadableHowItWorks = Loadable({
	loader: () => import('./HomeHowItWorks').then((m) => m.HowItWorks),
});

export const LoadableRecentPublicJobs = Loadable({
	loader: () => import('./RecentPublicJobs').then((m) => m.RecentPublicJobs),
});

const LoadableCaoWijzerHome = Loadable({
	loader: () => import('./CaoWijzerHome').then((m) => m.CaoWijzerHome),
});

const LoadableEmployers = Loadable({
	loader: () => import('./Employers').then((m) => m.Employers),
});

const WIDGETS: CustomPageWidgetComponents = {
	HomePageImage: LoadableHomePageImage,
	JobCategory: LoadableHomeJobCategory,
	LatestPublicNews: LoadableHomeLatestPublicNews,
	HowItWorks: LoadableHowItWorks,
	CustomTile: LoadableCustomHtml,
	FindJobs: LoadableHomeFindJobs,
	PublicRegistrationForm: LoadablePublicRegistrationForm,
	RecentPublicJobs: LoadableRecentPublicJobs,
	CaoWijzerHome: LoadableCaoWijzerHome,
	Employers: LoadableEmployers,
};

export const CustomPageWidgets: FC<React.PropsWithChildren<{ widgets: CustomPageWidgetsType }>> = ({ widgets }) => {
	return (
		<>
			{widgets.map((widget) => {
				const WidgetComponent = WIDGETS[widget.tileType];

				if (isUndefined(WidgetComponent)) return null;

				// Todo: remove ts-ignore and found correct solution for describe types for widgets
				return (
					<Fragment key={widget.tileType}>
						{/*// @ts-ignore*/}
						<WidgetComponent {...widget} />
					</Fragment>
				);
			})}
		</>
	);
};
